// Articles page filters and search
document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.article-filter-btn');
    const searchInput = document.querySelector('.articles-page-search-input');
    const countValue = document.querySelector('.articles-page-count-value');

    if (filterButtons.length === 0 && !searchInput) {
        return;
    }

    let currentFilter = 'all';
    let currentSearch = '';

    // Set first button as active
    if (filterButtons.length > 0) {
        filterButtons[0].classList.add('active');
    }

    function getCards() {
        return document.querySelectorAll('.article-card[data-category]');
    }

    // Функция для обновления счетчика
    function updateCount() {
        if (countValue) {
            var cards = getCards();
            var visible = 0;
            cards.forEach(function(card) { if (card.style.display !== 'none') visible++; });
            countValue.textContent = visible;
        }
    }

    // Функция для фильтрации и поиска
    function applyFiltersAndSearch() {
        getCards().forEach(card => {
            const cardCategory = (card.getAttribute('data-category') || 'all').trim().toLowerCase();
            const filter = currentFilter.toLowerCase();
            const cardTitle = (card.getAttribute('data-title') || '').toLowerCase();
            const cardExcerpt = (card.getAttribute('data-excerpt') || '').toLowerCase();
            const searchLower = currentSearch.toLowerCase();
            
            // Проверяем соответствие фильтру
            const matchesFilter = filter === 'all' || cardCategory === filter;
            const matchesSearch = !currentSearch || 
                                 cardTitle.includes(searchLower) || 
                                 cardExcerpt.includes(searchLower);
            
            if (matchesFilter && matchesSearch) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }
        });
        
        updateCount();
    }
    
    // Обработчики для фильтров
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            const filter = this.getAttribute('data-filter');
            currentFilter = filter;
            
            // Update active button
            filterButtons.forEach(btn => {
                btn.classList.remove('active');
            });
            this.classList.add('active');
            
            applyFiltersAndSearch();
        });
    });
    
    // Обработчик для поиска
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            currentSearch = this.value;
            applyFiltersAndSearch();
        });
    }
    
    document.addEventListener('articles:refilter', applyFiltersAndSearch);

    // Инициализация
    applyFiltersAndSearch();
});

// AJAX-подгрузка статей
document.addEventListener('DOMContentLoaded', function() {
    var loadMoreBtn = document.querySelector('.articles-load-more');
    if (!loadMoreBtn) return;

    var grid = document.querySelector('.articles-list');
    if (!grid) return;

    var months = ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'];

    function formatDate(dateStr) {
        if (!dateStr || dateStr.indexOf('0000') === 0) return '';
        var parts = dateStr.split(/[-\s]/);
        if (parts.length < 3) return dateStr;
        var day = parseInt(parts[2], 10);
        var monthIdx = parseInt(parts[1], 10) - 1;
        if (!day || monthIdx < 0 || monthIdx > 11) return '';
        return day + ' ' + months[monthIdx] + ' ' + parts[0];
    }

    function stripTags(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }

    function buildCard(item) {
        var cat = item.category_code || 'all';
        var shortText = stripTags(item.short || '');
        var authorName = item.author || 'Эксперт Меркурий';
        var readTime = (item.read_time && item.read_time !== '0') ? item.read_time : '5';
        var card = document.createElement('a');
        card.className = 'article-card bg-white rounded-2xl overflow-hidden border border-gray-100 hover-shadow-xl transition-all duration-300 group cursor-pointer block';
        card.href = '/articles/' + item.trans + '/';
        card.setAttribute('data-category', cat);
        card.setAttribute('data-title', item.name);
        card.setAttribute('data-excerpt', shortText);

        var imgHtml = '';
        if (item.img && item.img !== '0') {
            imgHtml = '<img class="w-full h-full object-cover group-hover-scale-110 transition-transform duration-500" src="' + item.img + '" alt="' + item.name.replace(/"/g, '&quot;') + '">';
        }

        var dateVal = item.rdate || item.date || '';
        var dateFormatted = formatDate(dateVal);
        var dateHtml = '';
        if (dateFormatted) {
            dateHtml = '<div class="article-date flex items-center gap-1"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg><span>' + dateFormatted + '</span></div>';
        }

        card.innerHTML =
            '<div class="article-image relative h-60 overflow-hidden">' + imgHtml + '</div>' +
            '<div class="article-content p-7">' +
                '<div class="flex items-center gap-4 text-sm text-gray-500 mb-4">' +
                    dateHtml +
                    '<div class="article-read-time flex items-center gap-1"><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg><span>' + readTime + ' мин</span></div>' +
                '</div>' +
                '<h3 class="article-title mb-3 line-clamp-2 group-hover-text-purple-600 transition-colors">' + item.name + '</h3>' +
                '<p class="article-excerpt text-gray-600 mb-4 line-clamp-3">' + shortText + '</p>' +
                '<div class="flex items-center justify-between pt-4 border-t border-gray-100">' +
                    '<div class="article-author flex items-center gap-2"><svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg><span class="text-sm text-gray-600">' + authorName + '</span></div>' +
                    '<span class="article-link text-purple-600 flex items-center gap-1 text-sm transition-colors group-hover-gap-2">Читать<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg></span>' +
                '</div>' +
            '</div>';

        return card;
    }

    loadMoreBtn.addEventListener('click', function() {
        var offset = parseInt(loadMoreBtn.getAttribute('data-offset'), 10);
        var total = parseInt(loadMoreBtn.getAttribute('data-total'), 10);
        var step = parseInt(loadMoreBtn.getAttribute('data-step'), 10);
        var btnText = loadMoreBtn.querySelector('.articles-load-more-text');

        btnText.textContent = 'Загрузка...';
        loadMoreBtn.disabled = true;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', window.location.pathname + '?ajax_load=1&offset=' + offset);
        xhr.onload = function() {
            if (xhr.status === 200) {
                var data = JSON.parse(xhr.responseText);
                if (data.items && data.items.length) {
                    data.items.forEach(function(item) {
                        grid.appendChild(buildCard(item));
                    });
                    offset += data.items.length;
                    loadMoreBtn.setAttribute('data-offset', offset);
                }
                document.dispatchEvent(new Event('articles:refilter'));
                if (offset >= total) {
                    loadMoreBtn.parentElement.style.display = 'none';
                } else {
                    btnText.textContent = 'Показать ещё';
                    loadMoreBtn.disabled = false;
                }
            }
        };
        xhr.send();
    });
});

// Слайдер "Читайте также" на странице статьи
document.addEventListener('DOMContentLoaded', function() {
    var relatedSliderEl = document.querySelector('.related-articles-slider');
    if (relatedSliderEl && typeof Swiper !== 'undefined') {
        new Swiper('.related-articles-slider', {
            slidesPerView: 1.2,
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: '.related-next',
                prevEl: '.related-prev',
            },
            breakpoints: {
                480: { slidesPerView: 1.5, spaceBetween: 20 },
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2.5, spaceBetween: 24 },
                1024: { slidesPerView: 3, spaceBetween: 24 },
                1280: { slidesPerView: 4, spaceBetween: 24 },
                1536: { slidesPerView: 5, spaceBetween: 24 },
            }
        });
    }
});




















